module.exports = __webpack_public_path__ + "img/voice-icon9.d1012c1.png";